import { SCENES, OFFSETS, BRAND, FEATURES, LEGAL_NOTES, TE } from "@/data/adPackage";

function fmt(sec) {
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = Math.floor(sec % 60);
  const ms = Math.round((sec - Math.floor(sec)) * 1000);
  const p = (n, l = 2) => String(n).padStart(l, "0");
  return `${p(h)}:${p(m)}:${p(s)},${p(ms, 3)}`;
}

export function buildSRT(mode = "vo", lang = "en") {
  let acc = 0;
  return SCENES.map((s, i) => {
    const start = acc;
    const end = acc + s.dur;
    acc = end;
    const text =
      lang === "te"
        ? mode === "vo"
          ? TE[s.id].vo
          : TE[s.id].caption
        : mode === "vo"
        ? s.vo
        : s.caption;
    return `${i + 1}\n${fmt(start)} --> ${fmt(end)}\n${text}\n`;
  }).join("\n");
}

export function buildScriptSheet() {
  const lines = [];
  lines.push("BiteGoFood — Product Launch Commercial");
  lines.push("16:9 Master · 60 seconds · Main VO version");
  lines.push(BRAND.poweredBy);
  lines.push("Objective: Drive restaurant owners to visit bitego.org and register.");
  lines.push("=".repeat(66));
  SCENES.forEach((s) => {
    const start = OFFSETS.map[s.id];
    const end = start + s.dur;
    lines.push("");
    lines.push(`SCENE ${s.index} — ${s.chapter}  |  ${start}s – ${end}s`);
    lines.push("-".repeat(66));
    lines.push(`VISUAL: ${s.shot}`);
    lines.push(`VOICE-OVER (EN): "${s.vo}"`);
    lines.push(`VOICE-OVER (TE): "${TE[s.id].vo}"`);
    lines.push(`ON-SCREEN (mute-friendly): ${onScreenText(s).join("  /  ")}`);
  });
  lines.push("");
  lines.push("=".repeat(66));
  lines.push("APPROVED CLAIMS & LEGAL SAFETY");
  LEGAL_NOTES.forEach((n, i) => lines.push(`${i + 1}. ${n}`));
  return lines.join("\n");
}

export function onScreenText(s) {
  const o = s.overlay || {};
  switch (s.variant) {
    case "headline":
      return [o.big, o.sub];
    case "brand":
      return [o.big, o.sub, o.pill];
    case "commission":
      return [o.big, o.sub, `${o.pricingTitle}: ${o.pricingLine}`];
    case "features":
      return [o.big, FEATURES.map((f) => f.label).join(" · ")];
    case "flow":
      return [o.big];
    case "growth":
      return o.lines;
    case "cta":
      return [
        BRAND.name,
        o.commission,
        `${o.big} ${o.big2}`,
        o.cta,
        BRAND.poweredBy,
      ];
    default:
      return [];
  }
}

export function buildShotList() {
  const lines = ["BiteGoFood — Shot List & Scene Timings", "=".repeat(60)];
  SCENES.forEach((s) => {
    const start = OFFSETS.map[s.id];
    lines.push("");
    lines.push(`#${s.index}  ${s.chapter}`);
    lines.push(`   In/Out: ${start}s → ${start + s.dur}s  (${s.dur}s)`);
    lines.push(`   Shot:   ${s.shot}`);
    lines.push(`   VO:     "${s.vo}"`);
  });
  return lines.join("\n");
}

export function buildCutGuide() {
  return [
    "BiteGoFood — Vertical-Safe (9:16) Cut Guide",
    "=".repeat(60),
    "",
    "The 16:9 master is composed center-safe so a 9:16 crop keeps all",
    "key text, the logo, UI cards and faces inside a centered column.",
    "",
    "Crop rule:",
    "  • From the 16:9 (1920×1080) master, crop a centered 608×1080 column",
    "    (a centered 9:16 window) — nothing critical falls outside it.",
    "  • Keep all headlines, the 18% claim, pricing card, feature chips,",
    "    logo and CTA within the central 56% width and central 80% height.",
    "",
    "Per-scene notes:",
    ...SCENES.map(
      (s) => `  • Scene ${s.index} (${s.chapter}): subject/text pre-centered — safe to crop.`
    ),
    "",
    "Subtitles: keep on the lower third but above the bottom 12% margin so",
    "mobile UI chrome (Instagram / WhatsApp) never overlaps them.",
  ].join("\n");
}

export function triggerDownload(filename, text, mime = "text/plain") {
  const blob = new Blob([text], { type: `${mime};charset=utf-8` });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
